// Libraries
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth0 } from "@auth0/auth0-react";

// Styles
import styles from "./index.module.css";

// Components
import { Grid, Popover, Typography } from "@mui/material";
import {
  GearIcon,
  LanguageIcon,
  LogoutIcon,
  ShieldIcon,
  UserIcon,
} from "../../../assets/icons";

// Utils
import getUserFromToken from "../../../utils/tokenHelper";

const UserMenu = ({
  canReachPages,
  userMenu,
  userMenuClose,
  handleLeftClick, // to admin or to tech
  handleCenterClick, // to change language or to clinic settings
  handleRightClick, // signout
  isAdmin,
  setIsAdmin,
  isAdminPage = false,
}) => {
  // internationalization
  const { t, i18n } = useTranslation();

  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (!setIsAdmin) return;
    const checkAdmin = async () => {
      const token = await getAccessTokenSilently();
      const { isAdmin } = getUserFromToken(token);

      setIsAdmin(isAdmin);
    };
    checkAdmin();
  }, [getAccessTokenSilently, setIsAdmin]);

  const customStyle = {
    width:
      window.innerWidth > 600
        ? i18n.language === "fr"
          ? "280px"
          : "200px"
        : "70%",
    top: window.innerWidth > 750 ? "30px" : "85px",
  };

  /* menu pop when open */
  return (
    <Popover
      sx={{ mt: 0 }}
      open={Boolean(userMenu)}
      anchorEl={userMenu}
      onClose={userMenuClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      PaperProps={{
        style: customStyle,
      }}
      classes={{
        paper: "py-4 px-2",
      }}
    >
      {canReachPages && isAdmin && (
        <button className={styles.menu_item} onClick={handleLeftClick}>
          <Grid container display="flex" alignItems="center" gap="8px">
            {isAdminPage ? (
              <UserIcon width="20px" height="20px" />
            ) : (
              <ShieldIcon width="20px" height="20px" />
            )}
            <Typography>
              {isAdminPage ? t("word_back_to_tech") : t("word_admin")}
            </Typography>
          </Grid>
        </button>
      )}
      <button className={styles.menu_item} onClick={handleCenterClick}>
        <Grid container display="flex" alignItems="center" gap="8px">
          {isAdminPage ? (
            <LanguageIcon width="20px" height="20px" />
          ) : (
            <GearIcon width="20px" height="20px" />
          )}
          <Typography>
            {isAdminPage ? t("word_language") : t("word_clinic_settings")}
          </Typography>
        </Grid>
      </button>

      <button className={styles.menu_item} onClick={handleRightClick}>
        <Grid container display="flex" alignItems="center" gap="8px">
          <LogoutIcon width="20px" height="20px" />
          <Typography>{t("sign_out")}</Typography>
        </Grid>
      </button>
      {/* </div> */}
    </Popover>
  );
};

export default UserMenu;
